export class CustomError extends Error {
	constructor(messageOrError: string | Error, name: string) {
		const message = messageOrError instanceof Error ? messageOrError.message : messageOrError;
		super(message);
		this.name = name;

		// Copy stack trace if an Error was passed
		if (messageOrError instanceof Error) {
			this.stack = messageOrError.stack;
		}
	}
}

export class SubmitError extends CustomError {
	constructor(messageOrError: string | Error) {
		super(messageOrError, 'SubmitError');
	}
}

export class EnvVariableError extends CustomError {
	constructor(messageOrError: string | Error) {
		super(messageOrError, 'EnvVariableError');
	}
}

export class BuilderError extends CustomError {
	constructor(messageOrError: string | Error) {
		super(messageOrError, 'BuilderError');
	}
}

export class ScriptError extends CustomError {
	constructor(messageOrError: string | Error) {
		super(messageOrError, 'ScriptError');
	}
}

export class TimeoutError extends CustomError {
	constructor(messageOrError: string | Error) {
		super(messageOrError, 'TimeoutError');
	}
}

export class FeatheryError extends CustomError {
	constructor(messageOrError: string | Error) {
		super(messageOrError, 'FeatheryError');
	}
}

export class LandingError extends CustomError {
	constructor(messageOrError: string | Error) {
		super(messageOrError, 'LandingError');
	}
}

/**
 * A failure in a thank-you page chat: Google's CES widget (its `chat-messenger-error` event) or the
 * Agentforce chat. The Sentry `api` tag tells them apart.
 */
export class WebChatError extends CustomError {
	constructor(messageOrError: string | Error) {
		super(messageOrError, 'WebChatError');
	}
}

// New error classes for better error categorization
export class TrustedFormError extends CustomError {
	constructor(messageOrError: string | Error) {
		super(messageOrError, 'TrustedFormError');
	}
}

export class HTTPError extends CustomError {
	public readonly status?: number;
	public readonly response?: unknown;

	constructor(messageOrError: string | Error, status?: number, response?: unknown) {
		super(messageOrError, 'HTTPError');
		this.status = status;
		this.response = response;
	}
}

export class APIError extends HTTPError {
	constructor(messageOrError: string | Error, status?: number, response?: unknown) {
		super(messageOrError, status, response);
		this.name = 'APIError';
	}
}

export class TrackingError extends CustomError {
	public readonly provider?: string;

	constructor(messageOrError: string | Error, provider?: string) {
		super(messageOrError, 'TrackingError');
		// Use Object.defineProperty to set readonly property
		Object.defineProperty(this, 'provider', { value: provider, writable: false });
	}
}

export class EverflowError extends CustomError {
	public readonly provider = 'everflow';

	constructor(messageOrError: string | Error) {
		super(messageOrError, 'EverflowError');
	}
}

export class DOMError extends CustomError {
	public readonly selector?: string;

	constructor(messageOrError: string | Error, selector?: string) {
		super(messageOrError, 'DOMError');
		// Use Object.defineProperty to set readonly property
		Object.defineProperty(this, 'selector', { value: selector, writable: false });
	}
}

export enum GeneralError {
	NoPageFound = 'No page found - 404',
}
